{
  "home_page": {
    "header": {
      "title": "Welcome to SparkLayer"
    }
  },
  "home_page_redirect_page": {
    "title": "SparkLayer is now managed in Shopify",
    "description": "Click the button below to set up and manage your SparkLayer in Shopify.",
    "action": "Continue in Shopify"
  }
}
